import { useEffect } from 'react';
import { useLocation } from 'react-router';
import type { PageType } from 'types';

import ViewEvent from '~/events/ViewEvent';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';

type Options<T> = {
  viewProperties?: T;
  viewType: PageType;
};

export default function useViewEvent<
  T extends Record<string, unknown> = Record<string, unknown>
>({ viewProperties, viewType }: Options<T>) {
  const { clientIp, isBot } = useRootData();
  const user = useUser();
  const { key } = useLocation();

  useEffect(() => {
    new ViewEvent({ clientIp, isBot, user, viewProperties, viewType }).send();
  }, [clientIp, isBot, key, user, viewProperties, viewType]);
}
